module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-white-1-26985969a11aa826805a065ba242a7c5.webp";